import React from 'react';
import { strings } from 'APP_ROOT/localization';
import ConfirmDialog from 'APP_ROOT/components/common/ConfirmDialog';
import SimpleProfileImage from 'APP_ROOT/components/SimpleProfileImage';

export default class MergeDialog extends React.Component {

    render() {

        const {
            isOpen,
            onOk,
            onCancel,
            onDismiss,
            facesToMerge,
        } = this.props;

        return (
            <ConfirmDialog
                isOpen={isOpen}
                contentLabel="merge-selected-faces"
                onOk={() => onOk(facesToMerge)}
                onCancel={onCancel}
                onDismiss={onDismiss}>

                <div className="row">
                    <div className="col"><h1>{strings.faces_merge_selected_faces_confirmation_title}</h1></div>
                </div>
                <div className="row">
                    <div className="alert alert-warning" role="alert">
                        {strings.faces_merge_selected_faces_confirmation_description}
                    </div>
                </div>
                <div className="row justify-content-center">
                    {facesToMerge.map(face => {
                        return (
                            <div className="col-auto text-center" key={face.identityId}>
                                <SimpleProfileImage.Small src={face.profileImageUrl} />
                                {face.name}
                            </div>
                        );
                    })}
                </div>
            </ConfirmDialog>
        );
    }
}
